import { render, staticRenderFns } from "./clientmind.vue?vue&type=template&id=13625e94&scoped=true&"
import script from "./clientmind.vue?vue&type=script&lang=js&"
export * from "./clientmind.vue?vue&type=script&lang=js&"
import style0 from "./clientmind.vue?vue&type=style&index=0&id=13625e94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13625e94",
  null
  
)

export default component.exports